import "url-search-params-polyfill";
import { Node } from "./tree.js";
import editorhelper from "./editorhelper.js";
import { htmlEncode, htmlDecode } from "js-htmlencode";
/* eslint-disable-next-line */
import {
  privateEncrypt
} from "crypto";
import * as d3 from "d3-selection";

export const editor = {
  data() {
    let nid = document.getElementById("nodeid").value;
    let startnode = new Node();
    startnode.name = "Start";
    startnode.id = 1;
    startnode.parentid = 0;
    startnode.level = 0;
    startnode.x = 0;
    startnode.y = 0;
    startnode.children = [];
    startnode.nodeType = START;
    return {
      uid: nid,
      nodes: [startnode],
      svg: null,
      s: null
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      var svg = document.getElementById("svg");
      if (svg.classList.contains("svg--check")) {
        this.checkSizeOfSvg();
      }
    });
    this.getchart();
    this.getChartMetadata();
  },
  methods: {
    htmldecode(c){
      let res = c.replace('<p>','').replace('</p>','<br/>');
      return htmlDecode(res);
    },
    getchart() {
      var self = this;
      let data = document.getElementById("data").value;
      let _js = JSON.parse(decodeURIComponent(data));
      let _n = editorhelper.maptonode(_js);

      self.nodes = [];
      self.nodes.push(_n);
      self.pathwayName = document.getElementById("pathwayname").value;
      self.renderchart();
      self.scrollIntoCenter();
    },
    getChartMetadata() {
      var self = this;
      let _jsmetadata = {
        Name: "N/A",
        LongDescription: "N/A",
        Authors: "N/A",
        Tags: "N/A",
        ReviewDate: -1,
        EvidenceBase: "N/A",
        ShowKeyButton: true
      };
      _jsmetadata.Name = document.getElementById("pathwayname").value;
      _jsmetadata.Authors = document.getElementById("authors").value;
      _jsmetadata.ReviewDate = document.getElementById("reviewdate").value;
      _jsmetadata.CreatedDate = document.getElementById("createddate").value;
      _jsmetadata.LastUpdatedDate = document.getElementById(
        "lastupdated"
      ).value;
      _jsmetadata.LongDescription = document.getElementById(
        "longdescription"
      ).value;
      _jsmetadata.Tags = document.getElementById("keywords").value;
      _jsmetadata.EvidenceBase = document.getElementById("evidenceBase").value;
      _jsmetadata.ShowKeyButton = document.getElementById("showKeyButton").value;
      console.log(document.getElementById("showKeyButton").value);
      console.log(_jsmetadata.ShowKeyButton);
      self.$root.$emit("loadPathwayMetadata", _jsmetadata);
    },

    renderchart() {
      if (this.s === null) {
        this.s = Snap("#svg");
        this.svg = d3.select("#svg");
        this.currentState = 1;
      }
      this.s.clear();
      var node = Diagram.calcposition(this.s, this.nodes[0]);
      this.renderConnections(node, true);
      this.rendernode(node, true);
    },

    renderchildren(parent) {
      var self = this;
      parent.children.forEach(n => {
        self.rendernode(n, true);
      });
    },

    getColourForRisk(r) {
      if (r == LOW) return "fill--success";
      if (r == MEDIUM) return "fill--warning";
      if (r == HIGH) return "fill--danger";
      return "fill--info";
    },

    getFlag(r) {
      if (r == HIGH) return "fill--white";
      return "d--n";
    },

    renderConnections(n, cont) {
      if (this.s === null) {
        this.s = Snap("#svg");
        this.svg = d3.select("#svg");
      }
      var self = this;
      var s = self.s;
      d3.selectAll("polyline.conn_" + n.id).remove();

      n.getOffsetConnections(this.nodes[0], s.getBBox().width * 0.5);

      n.connections
        .filter(function(el) {
          return el.type !== FALSEPARENT;
        })
        .forEach(x => {
          if (!x.xOffset) x.xOffset = 0;
          if (!x.yOffset) x.yOffset = 0;
          if (!x.label) x.label = "";
          if (!x.line) x.line = 1;
          else x.line = parseInt(x.line);
          if (!x.xCoord) x.xCoord = 0;
          if (cont) {
            x.xCoord = 0;
            x.overlapOffset = 0;
          }
          if (!x.label) x.label = "";
          let c = self.nodes[0].getdescendent(x.id);
          if (!c) {
            self.deleteConnection(n.id, x.id);
            return;
          }

          // Special cases
          if (x.type === FALSECHILD) {
            let x1 = n.x + n.width * 0.5;
            let y1 = n.y + n.height;
            let y2 = c.y;

            let offx = -20;

            if (n.x === c.x) {
              offx = 0;
            }
            if (n.x > c.x) {
              offx = 20;
            }
            if (offx === -20 && c.parentTree.x <= n.x) {
              offx = 0;
            }

            let x2 = c.x + c.width * 0.5 + offx;

            let line = s
              .polyline(x1, y1, x1, y1 + 30, x2, y1 + 30, x2, y2)
              .addClass("node__guides conn_" + n.id);

            if (x.line === 2) {
              line.attr({ "stroke-dasharray": "10 5" });
            }

            //draw down arrow
            let ax0 = c.x + c.width * 0.5 + offx; // mid point
            let ay0 = c.y - 5;
            let ax1 = c.x + c.width * 0.5 + 5 + offx; // right point
            let ay1 = c.y - 5;
            let ax2 = c.x + c.width * 0.5 + offx; // bottom point
            let ay2 = c.y;
            let ax3 = c.x + c.width * 0.5 - 5 + offx; // left point
            let ay3 = c.y - 5;

            s.polyline(
              ax0,
              ay0,
              ax1,
              ay1,
              ax2,
              ay2,
              ax3,
              ay3,
              ax0,
              ay0
            ).addClass("node__arrow");
          } else if (
            n.leftNeighbor &&
            n.leftNeighbor.id === c.id &&
            x.type !== INCOMING &&
            x.type !== BIDIRECTIONAL
          ) {
            let x1 = n.x;
            let y1 = n.y + n.height * 0.5;

            let line = s
              .polyline(x1, y1, c.x + c.width, y1)
              .addClass("node__guides")
              .addClass("conn_" + n.id);

            if (x.line === 2) {
              line.attr({ "stroke-dasharray": "10 5" });
            }

            //draw left arrow
            let ax0 = c.x + c.width + 5;
            let ay0 = c.y + c.height * 0.5;
            let ax1 = c.x + c.width + 5;
            let ay1 = c.y + c.height * 0.5 + 5;
            let ax2 = c.x + c.width;
            let ay2 = c.y + c.height * 0.5;
            let ax3 = c.x + c.width + 5;
            let ay3 = c.y + c.height * 0.5 - 5;
            s.polyline(ax0, ay0, ax1, ay1, ax2, ay2, ax3, ay3, ax0, ay0)
              .addClass("node__arrow")
              .addClass("conn_" + n.id);
          } else if (
            n.leftNeighbor &&
            n.leftNeighbor.id === c.id &&
            (x.type === INCOMING || x.type === BIDIRECTIONAL)
          ) {
            return;
          } else if (
            c &&
            n &&
            (n.rightNeighbor && n.rightNeighbor.id === c.id) &&
            x.type !== INCOMING
          ) {
            let x1 = n.x + n.width;
            let y1 = n.y + n.height * 0.5;

            let line = s
              .polyline(x1, y1, c.x, y1)
              .addClass("node__guides")
              .addClass("conn_" + n.id);

            if (x.line === 2) {
              line.attr({ "stroke-dasharray": "10 5" });
            }

            if (x.type === BIDIRECTIONAL) {
              self.drawLeftArrow(s, n.x + n.width, n.y + n.height * 0.5, n.id);
            }

            //draw right arrow
            let ax0 = c.x - 5;
            let ay0 = c.y + c.height * 0.5;
            let ax1 = c.x - 5;
            let ay1 = c.y + c.height * 0.5 + 5;
            let ax2 = c.x;
            let ay2 = c.y + c.height * 0.5;
            let ax3 = c.x - 5;
            let ay3 = c.y + c.height * 0.5 - 5;
            s.polyline(ax0, ay0, ax1, ay1, ax2, ay2, ax3, ay3, ax0, ay0)
              .addClass("node__arrow")
              .addClass("conn_" + n.id);
          } else if (
            n.rightNeighbor &&
            n.rightNeighbor.id === c.id &&
            x.type === INCOMING
          ) {
            return;
          } else if (
            c &&
            n &&
            (n.isLeftmostOnLevel(n.level) &&
              c.isLeftmostOnLevel(c.level) &&
              !(c.isRightmostOnLevel(c.level) && n.isRightmostOnLevel(n.level))) // &&
            // !(
            //   c.x < s.getBBox().width * 0.5 || n.x < s.getBBox().width * 0.5
            // )
          ) {
            let widest = 0;
            if (c.level > n.level) {
              widest = Diagram.getWidestLeftNodeBetween(c, n.level);
            } else {
              widest = Diagram.getWidestLeftNodeBetween(n, c.level);
            }
            let conns = c.getOffsetConnections(
              self.nodes[0],
              s.getBBox().width * 0.5
            );
            if (!conns.find(y => y.id === n.id)) return;
            x.xOffset = Math.max(
              x.xOffset,
              conns.find(y => y.id === n.id).xOffset
            );
            if (!conns.find(y => y.id === n.id).overlapOffset)
              conns.find(y => y.id === n.id).overlapOffset = 0;
            x.overlapOffset = Math.max(
              x.overlapOffset,
              conns.find(y => y.id === n.id).overlapOffset
            );
            if (!cont) {
              conns.find(y => y.id === n.id).overlapOffset;
            }

            if (x.type === BIDIRECTIONAL || x.type === INCOMING) {
              if (n.level < c.level || x.type === INCOMING) {
                widest += x.xOffset * -1;
                widest += x.overlapOffset * -1;
                x.xCoord = widest;

                if (Math.abs(n.level - c.level) > 1) {
                  let botNode = null;
                  if (n.level < c.level) {
                    botNode = c.parentTree;
                  } else {
                    botNode = n.parentTree;
                  }
                  let its = Math.abs(n.level - c.level);
                  for (let i = 1; i < its; i++) {
                    while (botNode && botNode.leftNeighbor)
                      botNode = botNode.leftNeighbor;
                    if (!botNode) break;
                    let connXs = botNode.connections
                      .map(z => z.xCoord)
                      .sort(function(a, b) {
                        return b - a;
                      });
                    while (connXs.find(z => z == x.xCoord)) {
                      x.overlapOffset += 25;
                      widest -= 25;
                      x.xCoord = widest;
                    }
                    botNode = botNode.parentTree;
                  }
                  if (x.overlapOffset > 0 && cont) {
                    self.renderConnections(c, false);
                  }
                }

                let line = s
                  .polyline(
                    widest,
                    n.level < c.level ? n.y + n.height : n.y,
                    widest,
                    n.y + x.yOffset,
                    n.x,
                    n.y + x.yOffset
                  )
                  .addClass("node__guides")
                  .addClass("conn_" + n.id);

                if (x.line === 2) {
                  line.attr({ "stroke-dasharray": "10 5" });
                }
                //draw right arrows
                self.drawRightArrow(s, n.x, n.y + x.yOffset, n.id);

                return;
              }
              if (x.type === BIDIRECTIONAL) {
                self.drawRightArrow(s, n.x, n.y + x.yOffset, n.id);
              }
            }
            widest += x.xOffset * -1;
            widest += x.overlapOffset * -1;
            x.xCoord = widest;

            if (Math.abs(n.level - c.level) > 1) {
              let botNode = null;
              if (n.level < c.level) {
                botNode = c.parentTree;
              } else {
                botNode = n.parentTree;
              }
              let its = Math.abs(n.level - c.level);
              for (let i = 1; i < its; i++) {
                while (botNode && botNode.leftNeighbor)
                  botNode = botNode.leftNeighbor;
                if (!botNode) break;
                let connXs = botNode.connections
                  .map(z => z.xCoord)
                  .sort(function(a, b) {
                    return b - a;
                  });
                while (connXs.find(z => z == x.xCoord)) {
                  x.overlapOffset += 25;
                  widest -= 25;
                  x.xCoord = widest;
                }
                botNode = botNode.parentTree;
              }
              if (x.overlapOffset > 0 && cont) {
                self.renderConnections(c, false);
              }
            } else {
              x.overlapOffset = 0;
            }

            let x2 = n.x;
            //let y2 = n.y + n.height * 0.5 + heightAdjust;

            let y2 = n.y + x.yOffset;

            let line = s
              .polyline(
                x2,
                y2,
                widest,
                y2,
                widest,
                n.level < c.level ? c.y : c.y + c.height // + c.height * 0.5,
                // c.x,
                // c.y + c.height * 0.5
              )
              .addClass("node__guides")
              .addClass("conn_" + n.id);

            if (x.line === 2) {
              line.attr({ "stroke-dasharray": "10 5" });
            }
          } else if (
            c &&
            n &&
            (n.isRightmostOnLevel(n.level) && c.isRightmostOnLevel(c.level))
          ) {
            let widest = 0;
            if (c.level > n.level) {
              widest = Diagram.getWidestRightNodeBetween(c, n.level);
            } else {
              widest = Diagram.getWidestRightNodeBetween(n, c.level);
            }
            let conns = c.getOffsetConnections(
              self.nodes[0],
              s.getBBox().width * 0.5
            );

            if (!conns.find(y => y.id === n.id)) return;
            x.xOffset = Math.max(
              x.xOffset,
              conns.find(y => y.id === n.id).xOffset
            );

            if (!conns.find(y => y.id === n.id).overlapOffset)
              conns.find(y => y.id === n.id).overlapOffset = 0;
            x.overlapOffset = Math.max(
              x.overlapOffset,
              conns.find(y => y.id === n.id).overlapOffset
            );
            if (!cont) {
              conns.find(y => y.id === n.id).overlapOffset;
            }

            if (x.type === BIDIRECTIONAL || x.type === INCOMING) {
              if (n.level < c.level || x.type === INCOMING) {
                widest += x.xOffset;
                widest += x.overlapOffset;
                x.xCoord = widest;

                if (Math.abs(n.level - c.level) > 1) {
                  let botNode = null;
                  if (n.level < c.level) {
                    botNode = c.parentTree;
                  } else {
                    botNode = n.parentTree;
                  }
                  let its = Math.abs(n.level - c.level);
                  for (let i = 1; i < its; i++) {
                    while (botNode && botNode.rightNeighbor)
                      botNode = botNode.rightNeighbor;
                    if (!botNode) break;
                    let connXs = botNode.connections
                      .map(z => z.xCoord)
                      .sort(function(a, b) {
                        return b - a;
                      });
                    while (connXs.find(z => z == x.xCoord)) {
                      x.overlapOffset += 25;
                      widest += 25;
                      x.xCoord = widest;
                    }
                    botNode = botNode.parentTree;
                  }
                  if (x.overlapOffset > 0 && cont) {
                    self.renderConnections(c, false);
                  }
                }

                let line = s
                  .polyline(
                    widest,
                    n.level < c.level ? n.y + n.height : n.y,
                    widest,
                    n.y + x.yOffset,
                    n.x + n.width,
                    n.y + x.yOffset
                  )
                  .addClass("node__guides")
                  .addClass("conn_" + n.id);

                if (x.line === 2) {
                  line.attr({ "stroke-dasharray": "10 5" });
                }
                //draw left arrows
                self.drawLeftArrow(s, n.x + n.width, n.y + x.yOffset, n.id);

                return;
              }
              if (x.type === BIDIRECTIONAL) {
                self.drawLeftArrow(s, n.x + n.width, n.y + x.yOffset, n.id);
              }
            }
            widest += x.xOffset;
            widest += x.overlapOffset;
            x.xCoord = widest;

            if (Math.abs(n.level - c.level) > 1) {
              let botNode = null;
              if (n.level < c.level) {
                botNode = c.parentTree;
              } else {
                botNode = n.parentTree;
              }
              let its = Math.abs(n.level - c.level);
              for (let i = 1; i < its; i++) {
                while (botNode && botNode.rightNeighbor)
                  botNode = botNode.rightNeighbor;
                if (!botNode) break;
                let connXs = botNode.connections
                  .map(z => z.xCoord)
                  .sort(function(a, b) {
                    return b - a;
                  });
                while (connXs.find(z => z == x.xCoord)) {
                  x.overlapOffset += 25;
                  widest += 25;
                  x.xCoord = widest;
                }
                botNode = botNode.parentTree;
              }
              if (x.overlapOffset > 0 && cont) {
                self.renderConnections(c, false);
              }
            }

            let x1 = n.x + n.width;
            let y1 = n.y + x.yOffset;

            let line = s
              .polyline(
                x1,
                y1,
                widest,
                y1,
                widest,
                n.level < c.level ? c.y : c.y + c.height
                // c.x + c.width,
                // c.y + c.height * 0.5
              )
              .addClass("node__guides")
              .addClass("conn_" + n.id);

            if (x.line === 2) {
              line.attr({ "stroke-dasharray": "10 5" });
            }
          } else {
            if (
              n.x === c.x &&
              (x.type === OUTGOING || x.type === BIDIRECTIONAL)
            ) {
              let x0 = n.x;
              let x1 = n.x - 25;
              let y0 = n.y + n.height * 0.5 - 45;
              let y1 = c.y + c.height * 0.5 + 45;
              if (n.getleftsibling()) {
                x0 += n.width;
                x1 += n.width + 50;
              }
              if (n.level < c.level) {
                y0 += 90;
                y1 -= 90;
              }

              if (
                x.type === OUTGOING ||
                (x.type === BIDIRECTIONAL && n.id < c.id)
              ) {
                let line = s
                  .polyline(x0, y0, x1, y0, x1, y1, x0, y1)
                  .addClass("node__guides")
                  .addClass("conn_" + n.id);

                if (x.line === 2) {
                  line.attr({ "stroke-dasharray": "10 5" });
                }
              }

              if (x.type === OUTGOING || x.type === BIDIRECTIONAL) {
                if (n.getleftsibling()) {
                  self.drawLeftArrow(s, c.x + c.width, y1, n.id);
                } else {
                  self.drawRightArrow(s, c.x, y1, n.id);
                }
              }
            } else if (x.type !== INCOMING) {
              let x0 = n.x;
              let x1 = c.x + c.width;
              let y0 = n.y + n.height * 0.5 - 25;
              let y1 = c.y + c.height * 0.5 + 25;
              let xOffset = 25;

              if (n.level < c.level) {
                y0 += 50;
                y1 -= 50;
              }
              if (n.x + n.width < c.x) {
                x0 = n.x + n.width;
                x1 = c.x;
                let midx = c.x;
                if (n.rightNeighbor && n.rightNeighbor.x < c.x) {
                  midx = n.rightNeighbor.x;
                  xOffset = midx - c.x - (midx - n.x - n.width) / 2;
                } else if (
                  c.leftNeighbor &&
                  c.leftNeighbor.x + c.leftNeighbor.width > x0
                ) {
                  midx = c.leftNeighbor.x + c.leftNeighbor.width;
                  xOffset = (c.x - midx) / -2;
                } else {
                  xOffset = midx - c.x - (midx - n.x - n.width) / 2;
                }
              } else if (c.x + c.width < n.x) {
                let midx = c.x + c.width;
                if (n.leftNeighbor && n.leftNeighbor.x > c.x) {
                  midx = n.leftNeighbor.x + n.leftNeighbor.width;
                  xOffset = midx - c.x - c.width + (n.x - midx) / 2;
                } else if (c.rightNeighbor && c.rightNeighbor.x < x0) {
                  midx = c.rightNeighbor.x;
                  xOffset = (midx - c.x - c.width) / 2;
                } else {
                  xOffset = (n.x - c.x - c.width) / 2;
                }
              } else if (n.x > c.x) {
                xOffset = 0;
                if (n.level < c.level) {
                  y1 = c.y;
                  x1 = n.x - (n.x - (c.x + c.width * 0.5)) / 2;
                } else {
                  y0 = n.y;
                  x0 =
                    n.x +
                    n.width * 0.5 -
                    (n.x + n.width * 0.5 - c.x - c.width) / 2;
                  xOffset = (n.x + n.width * 0.5 - c.x - c.width) / 2;
                }
              } else if (n.x < c.x) {
                xOffset = 0;
                if (n.level < c.level) {
                  y1 = c.y;
                  x0 = n.x + n.width;
                  x1 =
                    n.x + n.width - (n.x + n.width - (c.x + c.width * 0.5)) / 2;
                } else {
                  y0 = n.y;
                  x0 = n.x + n.width * 0.5 + (c.x - (n.x + n.width * 0.5)) / 2;
                  x1 = c.x;
                  xOffset = (c.x - n.x - n.width * 0.5) / -2;
                }
              }

              if (
                x.type === OUTGOING ||
                (x.type === BIDIRECTIONAL && n.id < c.id)
              ) {
                let line = s
                  .polyline(x0, y0, x1 + xOffset, y0, x1 + xOffset, y1, x1, y1)
                  .addClass("node__guides")
                  .addClass("conn_" + n.id);

                if (x.line === 2) {
                  line.attr({ "stroke-dasharray": "10 5" });
                }

                if (n.x + n.width < c.x) {
                  self.drawRightArrow(s, x1, y1, n.id);
                } else if (c.x + c.width < n.x) {
                  self.drawLeftArrow(s, x1, y1, n.id);
                } else if (n.x > c.x) {
                  if (n.level < c.level) {
                    self.drawDownArrow(s, x1, y1, n.id);
                  } else {
                    self.drawLeftArrow(s, x1, y1, n.id);
                  }
                } else if (n.x < c.x) {
                  if (n.level < c.level) {
                    self.drawDownArrow(s, x1, y1, n.id);
                  } else {
                    self.drawRightArrow(s, x1, y1, n.id);
                  }
                }
              }
              if (x.type === BIDIRECTIONAL && n.id > c.id) {
                if (n.x + n.width < c.x) {
                  self.drawRightArrow(s, x1, y1, n.id);
                } else if (c.x + c.width < n.x) {
                  self.drawLeftArrow(s, x1, y1, n.id);
                } else if (n.x > c.x) {
                  if (n.level < c.level) {
                    self.drawDownArrow(s, x1, y1, n.id);
                  } else {
                    self.drawLeftArrow(s, x1, y1, n.id);
                  }
                } else if (n.x < c.x) {
                  if (n.level < c.level) {
                    self.drawDownArrow(s, x1, y1, n.id);
                  } else {
                    self.drawRightArrow(s, x1, y1, n.id);
                  }
                }
              }
            }
          }
        });
      if (cont) {
        n.children.forEach(c => {
          c.level = n.level + 1;
          self.renderConnections(c, true);
        });
      }
    },

    rendernode(n, cont) {
      if (this.s === null) {
        this.s = Snap("#svg");
        this.svg = d3.select("#svg");
      }
      var self = this;
      var s = self.s;
      d3.select("g#i_" + n.id + ".node__box").remove();

      // Generated Icon Paths.
      let flagIcon =
        "M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z";
      let editIcon =
        "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z";
      let addIcon =
        "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z";
      let pathwayIcon =
        "M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z";
      let emailIcon =
        "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z";
      let phoneIcon =
        "M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z";
      let calcIcon =
        "M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z";
      let linkIcon = 
        "m459.654 233.373-90.531 90.5c-49.969 50-131.031 50-181 0-7.875-7.844-14.031-16.688-19.438-25.813l42.063-42.063c2-2.016 4.469-3.172 6.828-4.531 2.906 9.938 7.984 19.344 15.797 27.156 24.953 24.969 65.563 24.938 90.5 0l90.5-90.5c24.969-24.969 24.969-65.563 0-90.516-24.938-24.953-65.531-24.953-90.5 0l-32.188 32.219c-26.109-10.172-54.25-12.906-81.641-8.891l68.578-68.578c50-49.984 131.031-49.984 181.031 0 49.97 49.986 49.97 131.033.001 181.017zM220.326 382.186l-32.203 32.219c-24.953 24.938-65.563 24.938-90.516 0-24.953-24.969-24.953-65.563 0-90.531l90.516-90.5c24.969-24.969 65.547-24.969 90.5 0 7.797 7.797 12.875 17.203 15.813 27.125 2.375-1.375 4.813-2.5 6.813-4.5l42.063-42.047c-5.375-9.156-11.563-17.969-19.438-25.828-49.969-49.984-131.031-49.984-181.016 0l-90.5 90.5c-49.984 50-49.984 131.031 0 181.031 49.984 49.969 131.031 49.969 181.016 0l68.594-68.594c-27.407 4.031-55.548 1.281-81.642-8.875z";
      let flagX = n.x + 10;
      let flagY = n.y + 5;

      // Generated Icon Viewport Settings to help resize accordingly.
      let icS = 12;
      let icC = 0;
      let icV = 512;

      let pathwayDimension = 640;
      let infoDimension = 192;

      let x0 = n.x + n.width * 0.5;
      let y0 = n.y + n.height;

      n.children.forEach(c => {
        if (!c.parentLabel) c.parentLabel = "";
        if (!c.line) c.line = 1;
        else c.line = parseInt(c.line);

        let offx = 0;
        if (
          c.connections.filter(function(el) {
            return el.type === FALSEPARENT;
          }).length > 0
        ) {
          if (!c.getleftsibling() && c.getrightsibling()) {
            offx = 20;
          } else if (!c.getrightsibling() && c.getleftsibling()) {
            offx = -20;
          }
        }

        let line = s
          .polyline(
            x0,
            y0,
            x0,
            y0 + 30,
            c.x + c.width * 0.5 + offx,
            y0 + 30,
            c.x + c.width * 0.5 + offx,
            c.y
          )
          .addClass("node__guides");

        if (c.line == 2) {
          line.attr({ "stroke-dasharray": "10 5" });
        }

        //draw down arrow
        let ax0 = c.x + c.width * 0.5 + offx; // mid point
        let ay0 = c.y - 5;
        let ax1 = c.x + c.width * 0.5 + 5 + offx; // right point
        let ay1 = c.y - 5;
        let ax2 = c.x + c.width * 0.5 + offx; // bottom point
        let ay2 = c.y;
        let ax3 = c.x + c.width * 0.5 - 5 + offx; // left point
        let ay3 = c.y - 5;

        s.polyline(ax0, ay0, ax1, ay1, ax2, ay2, ax3, ay3, ax0, ay0).addClass(
          "node__arrow"
        );

        let label = s
          .text(c.x + c.width * 0.5 + 10, y0 + 52, c.parentLabel.toUpperCase())
          .attr({
            fontWeight: "bold",
            fontSize: "75%"
          });

        if (
          c.connections.filter(function(el) {
            return el.type === FALSEPARENT;
          }).length > 0
        ) {
          label.attr({
            y: y0 + 22,
            x: x0 + 10
          });

          let vp = self.nodes[0].getdescendent(
            c.connections.filter(function(el) {
              return el.type === FALSEPARENT;
            })[0].id
          );
          if (vp.x < n.x) {
            label.attr({
              x: x0 - label.node.getComputedTextLength() - 10
            });
          } else if (n.x > c.x) {
            label.attr({
              x: x0 - label.node.getComputedTextLength() - 10
            });
          }
        }

        if (
          n.connections.filter(function(el) {
            return el.type === FALSECHILD;
          }).length > 0
        ) {
          let vp = self.nodes[0].getdescendent(
            n.connections.filter(function(el) {
              return el.type === FALSECHILD;
            })[0].id
          );

          if (vp.x > n.x) {
            label.attr({
              x: x0 - label.node.getComputedTextLength() - 10
            });
          }
        }
      });

      n.getOffsetConnections(this.nodes[0], s.getBBox().width * 0.5);

      n.connections
        .filter(function(el) {
          return el.type !== FALSEPARENT;
        })
        .forEach(x => {
          if (!x.xOffset) x.xOffset = 0;
          if (!x.yOffset) x.yOffset = 0;
          if (!x.label) x.label = "";
          if (!x.line) x.line = 1;
          else x.line = parseInt(x.line);
          // if (!x.xCoord) x.xCoord = 0;
          // x.overlapOffset = 0;
          if (!x.label) x.label = "";
          let c = self.nodes[0].getdescendent(x.id);
          if (!c) {
            self.deleteConnection(n.id, x.id);
            return;
          }

          // Special cases
          if (x.type === FALSECHILD) {
            let x1 = n.x + n.width * 0.5;
            let y1 = n.y + n.height;

            let label = s.text(x1 + 15, y1 + 22, x.label.toUpperCase()).attr({
              fontWeight: "bold",
              fontSize: "75%"
            });

            if (n.x > c.x) {
              label.attr({
                x: x1 - label.node.getComputedTextLength() - 15
              });
            }
          } else if (
            n.leftNeighbor &&
            n.leftNeighbor.id === c.id &&
            x.type !== INCOMING &&
            x.type !== BIDIRECTIONAL
          ) {
            let x1 = n.x;
            let y1 = n.y + n.height * 0.5;

            let label = s.text(x1 - 40, y1 + 15, x.label.toUpperCase()).attr({
              fontWeight: "bold",
              fontSize: "75%"
            });

            label.attr({
              x: x1 - label.node.getComputedTextLength() - 5
            });
          } else if (
            n.leftNeighbor &&
            n.leftNeighbor.id === c.id &&
            (x.type === INCOMING || x.type === BIDIRECTIONAL)
          ) {
            return;
          } else if (
            c &&
            n &&
            (n.rightNeighbor && n.rightNeighbor.id === c.id) &&
            x.type !== INCOMING
          ) {
            let x1 = n.x + n.width;
            let y1 = n.y + n.height * 0.5;

            s.text(x1 + 5, y1 + 15, x.label.toUpperCase()).attr({
              fontWeight: "bold",
              fontSize: "75%"
            });

            if (x.type === BIDIRECTIONAL) {
              let label = s
                .text(
                  c.x - 40,
                  c.y + c.height * 0.5 + 15,
                  c.connections.find(z => z.id === n.id).label.toUpperCase()
                )
                .attr({
                  fontWeight: "bold",
                  fontSize: "75%"
                });

              label.attr({
                x: c.x - label.node.getComputedTextLength() - 5
              });
            }
          } else if (
            c &&
            n &&
            (n.rightNeighbor && n.rightNeighbor.id === c.id) &&
            x.type === INCOMING
          ) {
            return;
          } else if (
            c &&
            n &&
            (n.isLeftmostOnLevel(n.level) &&
              c.isLeftmostOnLevel(c.level) &&
              !(c.isRightmostOnLevel(c.level) && n.isRightmostOnLevel(n.level))) // &&
            // !(
            //   c.x < s.getBBox().width * 0.5 || n.x < s.getBBox().width * 0.5
            // )
          ) {
            if (x.type === BIDIRECTIONAL || x.type === INCOMING) {
              if (n.level < c.level || x.type === INCOMING) {
                let belowLabel = s
                  .text(n.x - 40, n.y + x.yOffset + 15, x.label.toUpperCase())
                  .attr({
                    fontWeight: "bold",
                    fontSize: "75%",
                    stroke: "#fafafa",
                    strokeWidth: "5px",
                    strokeOpacity: 0.9
                  });

                let label = s.text(
                  n.x - 40,
                  n.y + x.yOffset + 15,
                  x.label.toUpperCase()
                );

                belowLabel.attr({
                  x: n.x - label.node.getComputedTextLength() - 5
                });

                label.attr({
                  x: n.x - label.node.getComputedTextLength() - 5
                });

                return;
              }
            }

            let x2 = n.x;

            let y2 = n.y + x.yOffset;

            let belowLabel = s
              .text(x2 - 40, y2 + 15, x.label.toUpperCase())
              .attr({
                fontWeight: "bold",
                fontSize: "75%",
                stroke: "#fafafa",
                strokeWidth: "5px",
                strokeOpacity: 0.9
              });

            let label = s.text(x2 - 40, y2 + 15, x.label.toUpperCase()).attr({
              fontWeight: "bold",
              fontSize: "75%"
            });

            belowLabel.attr({
              x: x2 - belowLabel.node.getComputedTextLength() - 5
            });

            label.attr({
              x: x2 - label.node.getComputedTextLength() - 5
            });
          } else if (
            c &&
            n &&
            (n.isRightmostOnLevel(n.level) && c.isRightmostOnLevel(c.level))
          ) {
            if (x.type === BIDIRECTIONAL || x.type === INCOMING) {
              if (n.level < c.level || x.type === INCOMING) {
                s.text(
                  n.x + n.width + 5,
                  n.y + x.yOffset + 15,
                  x.label.toUpperCase()
                ).attr({
                  fontWeight: "bold",
                  fontSize: "75%",
                  stroke: "#fafafa",
                  strokeWidth: "5px",
                  strokeOpacity: 0.9
                });

                s.text(
                  n.x + n.width + 5,
                  n.y + x.yOffset + 15,
                  x.label.toUpperCase()
                ).attr({
                  fontWeight: "bold",
                  fontSize: "75%"
                });

                return;
              }
            }

            let x1 = n.x + n.width;
            let y1 = n.y + x.yOffset;

            s.text(x1 + 5, y1 + 15, x.label.toUpperCase()).attr({
              fontWeight: "bold",
              fontSize: "75%",
              stroke: "#fafafa",
              strokeWidth: "5px",
              strokeOpacity: 0.9
            });

            s.text(x1 + 5, y1 + 15, x.label.toUpperCase()).attr({
              fontWeight: "bold",
              fontSize: "75%"
            });
          } else {
            if (
              n.x === c.x &&
              (x.type === OUTGOING || x.type === BIDIRECTIONAL)
            ) {
              let x0 = n.x;
              let y0 = n.y + n.height * 0.5 - 45;
              if (n.getleftsibling()) {
                x0 += n.width;
              }
              if (n.level < c.level) {
                y0 += 90;
              }

              if (x.type === OUTGOING || x.type === BIDIRECTIONAL) {
                if (n.getleftsibling()) {
                  s.text(x0 + 5, y0 + 15, x.label.toUpperCase()).attr({
                    fontWeight: "bold",
                    fontSize: "75%",
                    stroke: "#e7e7e7",
                    strokeWidth: "5px",
                    strokeOpacity: 0.9
                  });

                  s.text(x0 + 5, y0 + 15, x.label.toUpperCase()).attr({
                    fontWeight: "bold",
                    fontSize: "75%"
                  });
                } else {
                  let belowLabel = s
                    .text(x0 - 40, y0 + 15, x.label.toUpperCase())
                    .attr({
                      fontWeight: "bold",
                      fontSize: "75%",
                      stroke: "#e7e7e7",
                      strokeWidth: "5px",
                      strokeOpacity: 0.9
                    });

                  let label = s
                    .text(x0 - 40, y0 + 15, x.label.toUpperCase())
                    .attr({
                      fontWeight: "bold",
                      fontSize: "75%"
                    });

                  belowLabel.attr({
                    x: x0 - belowLabel.node.getComputedTextLength() - 5
                  });

                  label.attr({
                    x: x0 - label.node.getComputedTextLength() - 5
                  });
                }
              }
            } else if (x.type !== INCOMING) {
              let x0 = n.x;
              let y0 = n.y + n.height * 0.5 - 25;

              if (n.level < c.level) {
                y0 += 50;
              }
              if (n.x + n.width < c.x) {
                x0 = n.x + n.width;
                s.text(x0 + 5, y0 + 15, x.label.toUpperCase()).attr({
                  fontWeight: "bold",
                  fontSize: "75%",
                  stroke: "#e7e7e7",
                  strokeWidth: "5px",
                  strokeOpacity: 0.9
                });

                s.text(x0 + 5, y0 + 15, x.label.toUpperCase()).attr({
                  fontWeight: "bold",
                  fontSize: "75%"
                });
              } else if (c.x + c.width < n.x) {
                let belowLabel = s
                  .text(x0 - 40, y0 + 15, x.label.toUpperCase())
                  .attr({
                    fontWeight: "bold",
                    fontSize: "75%",
                    stroke: "#e7e7e7",
                    strokeWidth: "5px",
                    strokeOpacity: 0.9
                  });

                let label = s
                  .text(x0 - 40, y0 + 15, x.label.toUpperCase())
                  .attr({
                    fontWeight: "bold",
                    fontSize: "75%"
                  });

                belowLabel.attr({
                  x: x0 - belowLabel.node.getComputedTextLength() - 5
                });

                label.attr({
                  x: x0 - label.node.getComputedTextLength() - 5
                });
              } else if (n.x > c.x) {
                if (n.level < c.level) {
                  let belowLabel = s
                    .text(x0 - 40, y0 + 15, x.label.toUpperCase())
                    .attr({
                      fontWeight: "bold",
                      fontSize: "75%",
                      stroke: "#e7e7e7",
                      strokeWidth: "5px",
                      strokeOpacity: 0.9
                    });

                  let label = s
                    .text(x0 - 40, y0 + 15, x.label.toUpperCase())
                    .attr({
                      fontWeight: "bold",
                      fontSize: "75%"
                    });

                  belowLabel.attr({
                    x: x0 - belowLabel.node.getComputedTextLength() - 5
                  });

                  label.attr({
                    x: x0 - label.node.getComputedTextLength() - 5
                  });
                } else {
                  y0 = n.y;
                  x0 =
                    n.x +
                    n.width * 0.5 -
                    (n.x + n.width * 0.5 - c.x - c.width) / 2;
                  let belowLabel = s
                    .text(x0 - 40, y0 - 7, x.label.toUpperCase())
                    .attr({
                      fontWeight: "bold",
                      fontSize: "75%",
                      stroke: "#e7e7e7",
                      strokeWidth: "5px",
                      strokeOpacity: 0.9
                    });

                  let label = s
                    .text(x0 - 40, y0 - 7, x.label.toUpperCase())
                    .attr({
                      fontWeight: "bold",
                      fontSize: "75%"
                    });

                  belowLabel.attr({
                    x: x0 - belowLabel.node.getComputedTextLength() - 5
                  });

                  label.attr({
                    x: x0 - label.node.getComputedTextLength() - 5
                  });
                }
              } else if (n.x < c.x) {
                if (n.level < c.level) {
                  x0 = n.x + n.width;
                  s.text(x0 + 5, y0 + 15, x.label.toUpperCase()).attr({
                    fontWeight: "bold",
                    fontSize: "75%",
                    stroke: "#e7e7e7",
                    strokeWidth: "5px",
                    strokeOpacity: 0.9
                  });

                  s.text(x0 + 5, y0 + 15, x.label.toUpperCase()).attr({
                    fontWeight: "bold",
                    fontSize: "75%"
                  });
                } else {
                  y0 = n.y;
                  x0 = n.x + n.width * 0.5 + (c.x - (n.x + n.width * 0.5)) / 2;
                  s.text(x0 + 5, y0 - 7, x.label.toUpperCase()).attr({
                    fontWeight: "bold",
                    fontSize: "75%",
                    stroke: "#e7e7e7",
                    strokeWidth: "5px",
                    strokeOpacity: 0.9
                  });

                  s.text(x0 + 5, y0 - 7, x.label.toUpperCase()).attr({
                    fontWeight: "bold",
                    fontSize: "75%"
                  });
                }
              }
            }
          }
        });

      let startNodeBg = s
        .path(
          "M" +
            (n.x + BOXWIDTH - 40) +
            "," +
            (n.y - 20) +
            " h0 a20,20 0 0 1 20,20 v10 a20,20 0 0 1 -20,20 h-120 a20,20 0 0 1 -20,-20 v-10 a20,20 0 0 1 20,-20 z"
        )
        .addClass("fill--default")
        .attr({ stroke: "black", strokeWidth: "1" });

      let startNodeText = s
        .text(n.x + 78, n.y - 3, "START")
        .addClass("fill--primary");

      let finishNodeBg = s
        .path(
          "M" +
            (n.x + BOXWIDTH - 40) +
            "," +
            (n.y + BOXHEIGHT - 30) +
            " h0 a20,20 0 0 1 20,20 v10 a20,20 0 0 1 -20,20 h-120 a20,20 0 0 1 -20,-20 v-10 a20,20 0 0 1 20,-20 z"
        )
        .addClass("fill--default")
        .attr({ stroke: "black", strokeWidth: "1" });

      let finishNodeText = s
        .text(n.x + 76, n.y + BOXHEIGHT + 15, "FINISH")
        .addClass("fill--primary");

      let startNode = s.group(startNodeBg, startNodeText).attr({
        datatype: "start-node",
        nodeid: n.id
      });

      if (n.nodeType !== START) {
        startNode.attr({ display: "none" });
      }

      let finishNode = s.group(finishNodeBg, finishNodeText).attr({
        datatype: "finish-node",
        nodeid: n.id
      });

      if (n.nodeType !== END) {
        finishNode.attr({ display: "none" });
      }

      let content = s
        .rect(n.x + 1, n.y + 1, BOXWIDTH - 2, BOXHEIGHT - 2)
        .addClass("fill--white")
        .attr({ stroke: "black", strokeWidth: "1" });

      let flagPosition =
        "translate(" + (n.x + 5) + "," + (n.y + 4) + ") scale(0.025)";

      let drawFlag = s
        .path(flagIcon)
        .addClass(self.getFlag(n.riskSeverity))
        .attr({
          transform: flagPosition
        });

      let risk = s
        .rect(n.x + 1, n.y + 1, BOXWIDTH - 2, 20)
        .addClass(self.getColourForRisk(n.riskSeverity));

      let addbuttonbox = null;

      //add button
      if (n.nodeType !== END) {
        let addbutton = s
          .circle(n.x + BOXWIDTH * 0.5, n.y + BOXHEIGHT, 15)
          .addClass("node__add");

        let addbuttontext = s.svg(
          n.x + BOXWIDTH * 0.5 - 7,
          n.y + BOXHEIGHT - 8,
          icS + 5,
          icS + 5,
          icC,
          icC,
          icV,
          icV
        );

        addbuttontext.append(
          s.path(addIcon).addClass("node__text fill--primary")
        );

        addbuttonbox = s.group(addbutton, addbuttontext).attr({
          datatype: "add-node",
          nodeid: n.id
        });

        addbuttonbox.click(function clicks(e) {
          e.stopPropagation();
          self.addnode(parseInt(n.id, 10), parseInt(n.level, 10));
        });
      } else {
        addbuttonbox = s.rect(0, 0, 0, 0);
      }
      let titletext = s
        .text(n.x + 10, n.y + 40, this.htmldecode(n.name))
        .addClass("node__title");

      let titleElement = document.createElement("title");
      titleElement.innerHtml = n.name;

      let summaryText = s
        .text(n.x + 10, n.y + 60, this.htmldecode(n.shortDescription))
        .addClass("node__summary fill--black");

      let editTitle = document.createElement("title");
      editTitle.innerHtml = "Edit Node";

      let editButton = s
        .circle(n.x + BOXWIDTH - 20, n.y + BOXHEIGHT - 20, 12, 12, 0, 0)
        .addClass("node__edit");

      let dimension;

      if (n.nodeFunction == "url") {
        dimension = pathwayDimension;
      } else if (n.nodeFunction == "email" || n.nodeFunction == "phone") {
        dimension = 512;
      } else if (n.nodeFunction == "calc") {
        dimension = 540;
      } else {
        dimension = infoDimension;
      }

      let editText;

      let nodePosX = n.x + BOXWIDTH - 22;
      let nodePosY = n.y + BOXHEIGHT - 26;

      let infoPosition =
        "translate(" + nodePosX + "," + nodePosY + ") scale(0.025)";
      let pathPosition =
        "translate(" + (nodePosX - 4) + "," + nodePosY + ") scale(0.020)";
      let emailPosition =
        "translate(" + (nodePosX - 4) + "," + nodePosY + ") scale(0.020)";
      let phonePosition =
        "translate(" + (nodePosX - 4) + "," + nodePosY + ") scale(0.020)";
      let calcPosition =
        "translate(" + (nodePosX - 4) + "," + nodePosY + ") scale(0.020)";

      if (n.nodeFunction == "url") {
        editText = s
          .path(pathwayIcon)
          .addClass("node__text fill--secondary")
          .attr({
            transform: pathPosition
          });
      } else if (n.nodeFunction == "email") {
        editText = s
          .path(emailIcon)
          .addClass("node__text fill--secondary")
          .attr({
            transform: emailPosition
          });
      } else if (n.nodeFunction == "phone") {
        editText = s
          .path(phoneIcon)
          .addClass("node__text fill--secondary")
          .attr({
            transform: phonePosition
          });
      } else if (n.nodeFunction == "calc") {
        editText = s
          .path(calcIcon)
          .addClass("node__text fill--secondary")
          .attr({
            transform: calcPosition
          });
      } else if (n.nodeFunction == "exturl") {
        editText = s
          .path(linkIcon)
          .addClass("node__text fill--secondary")
          .attr({
            transform: calcPosition
          });
      } else {
        editText = s
          .path(editIcon)
          .addClass("node__text fill--secondary")
          .attr({
            transform: infoPosition
          });
      }

      let editBox = s.group(editButton, editText).attr({
        datatype: "view-node",
        nodeid: n.id
      });

      if (n.showInfoBtn && n.nodeFunction=="") {
        editBox.attr({ opacity: 0.0 });
      } else {
        editBox.attr({ opacity: 1.0 });
      }

      let careText = s
        .text(n.x + 10, n.y + BOXHEIGHT - 10, n.careSetting.toUpperCase())
        .addClass("node__care");

      /* eslint-disable-next-line */
      let nodebox =
        n.parentid > 0
          ? s
              .group(
                startNode,
                finishNode,
                content,
                risk,
                drawFlag,
                addbuttonbox,
                editBox,
                titletext,
                summaryText,
                careText
              )
              .attr({
                class: "node__box",
                datatype: "view-node",
                level: n.level,
                id: "i_" + n.id,
                parentid: n.parentid
              })
          : s
              .group(
                startNode,
                finishNode,
                content,
                risk,
                drawFlag,
                addbuttonbox,
                editBox,
                titletext,
                summaryText,
                careText
              )
              .attr({
                class: "node__box",
                datatype: "view-node",
                level: n.level,
                id: "i_" + n.id,
                parentid: n.parentid
              });

      if (cont) {
        this.renderchildren(n);
      }

      nodebox.click(function(e) {
        e.stopPropagation();

        console.log("nodeFunction: ",n.nodeFunction);

        console.log("external url: ", n.externalUrl);

          if (typeof Native != "undefined") {
            let linkdata = { title: "", nodeid: -1, href: "", target: "" };
            if (n.umbraconodeid !== "") {
              linkdata.nodeid = n.umbraconodeid;
            }
            if (n.nodeFunction == "url" && n.pathwayUrl !== "") {
              linkdata.href = n.pathwayUrl;
              self.$root.$emit("linkclickevent", linkdata);
            } else if (n.nodeFunction == "calc" && n.calculatorUrl !== "") {
              linkdata.href = n.calculatorUrl;
              self.$root.$emit("linkclickevent", linkdata);
            } else if (n.nodeFunction == "email" && n.emailAddress !== "") {
              linkdata.href = "mailto:" + n.emailAddress;
              self.$root.$emit("linkclickevent", linkdata);
            } else if (n.nodeFunction == "exturl" && n.externalUrl !== "") {
              linkdata.href = n.externalUrl;
              self.$root.$emit("linkclickevent", linkdata);
            } else if (n.nodeFunction == "phone" && n.telephone !== "") {
              linkdata.href = "tel:" + n.telephone.replace(/\s/g, "");
              self.$root.$emit("linkclickevent", linkdata);
            } else {
              if (n.showInfoBtn == null || n.showInfoBtn == global.SHOWINFOBTN) {
                self.editNode(n);
                self.$root.$emit("removeActiveNode");
                self.svg
                  .selectAll("g#i_" + n.id + ".node__box")
                  .classed("node__box--active", true);
              }
            }
          } else {
            if (n.nodeFunction == "url" && n.pathwayUrl !== "") {
              if (n.pathwayUrl.startsWith("http")) {
                window.open(n.pathwayUrl);
              } else {
                window.location = n.pathwayUrl;
              }
            } else if (n.nodeFunction == "calc" && n.calculatorUrl !== "") {
              if (n.calculatorUrl.startsWith("http")) {
                window.open(n.calculatorUrl);
              } else {
                window.location = n.calculatorUrl;
              }
            } else if (n.nodeFunction == "email" && n.emailAddress !== "") {
              document.location.href = "mailto:" + n.emailAddress;
            } else if (n.nodeFunction == "exturl" && n.externalUrl !== "") {
              if (n.externalUrl.startsWith("/")) { //if url is relative, open in same tab
                window.open(n.externalUrl, "_self");
              }  else {
                window.open(n.externalUrl);
              }
              
            } else if (n.nodeFunction == "phone" && n.telephone !== "") {
              document.location.href = "tel:" + n.telephone;
            } else {
              if (n.showInfoBtn == null || n.showInfoBtn == global.SHOWINFOBTN) {
                console.log("fallback to else: ",n.nodeFunction);
                self.editNode(n);
                self.$root.$emit("removeActiveNode");
                self.svg
                  .selectAll("g#i_" + n.id + ".node__box")
                  .classed("node__box--active", true);
              }
            }
          }
        }
        );

      self.svg.selectAll("g#i_" + n.id + ".node__box").call(self.wrapText, 180);
    },

    // Where (x,y) is the arrow head
    drawLeftArrow(s, x, y, id) {
      let ax0 = x + 5;
      let ay0 = y;
      let ax1 = x + 5;
      let ay1 = y + 5;
      let ax2 = x;
      let ay2 = y;
      let ax3 = x + 5;
      let ay3 = y - 5;
      s.polyline(ax0, ay0, ax1, ay1, ax2, ay2, ax3, ay3, ax0, ay0)
        .addClass("node__arrow")
        .addClass("conn_" + id);
    },

    // Where (x,y) is the arrow head
    drawRightArrow(s, x, y, id) {
      let ax0 = x - 5;
      let ay0 = y;
      let ax1 = x - 5;
      let ay1 = y + 5;
      let ax2 = x;
      let ay2 = y;
      let ax3 = x - 5;
      let ay3 = y - 5;
      s.polyline(ax0, ay0, ax1, ay1, ax2, ay2, ax3, ay3, ax0, ay0)
        .addClass("node__arrow")
        .addClass("conn_" + id);
    },

    // Where (x,y) is the arrow head
    drawDownArrow(s, x, y, id) {
      let ax0 = x;
      let ay0 = y - 5; // BACK
      let ax1 = x - 5;
      let ay1 = y - 5;
      let ax2 = x; // HEAD
      let ay2 = y;
      let ax3 = x + 5;
      let ay3 = y - 5;
      s.polyline(ax0, ay0, ax1, ay1, ax2, ay2, ax3, ay3, ax0, ay0)
        .addClass("node__arrow")
        .addClass("conn_" + id);
    },

    addnode(pid, level, undoAction, existingId) {
      var self = this;
      let newnode = new Node();
      newnode.level = level + 1;
      newnode.name =
        "Node title " + document.querySelectorAll(".node__box").length;
      if (existingId && existingId > 0) newnode.id = existingId;
      this.nodes[0].getdescendent(pid).addchild(newnode);

      this.renderchart();

      if (!undoAction) {
        var prev = {
          undoType: "ADD",
          id: newnode.id,
          pid: pid
        };
        window.sessionStorage.setItem(
          self.currentState.toString(),
          JSON.stringify(prev)
        );
        self.currentState++;
      }
      return newnode;
    },

    deleteNode(n, p, undoAction) {
      if (this.editingNode === n.id) {
        this.$root.$emit("closePanel");
      }

      if (!undoAction) {
        let prev = n.toObjectString("DELETE");

        window.sessionStorage.setItem(this.currentState.toString(), prev);
        this.currentState++;
      }

      let idx = -1;
      for (var i = 0; i < p.children.length; i++) {
        if (p.children[i].id === n.id) {
          idx = i;
        }
      }
      if (idx > -1) {
        p.children.splice(idx, 1);
        this.renderchart();
      }

      for (var j = 0; j < n.connections.length; j++) {
        this.deleteConnection(n, n.connections[j].n);
      }

      for (var k = 0; k < n.children.length; k++) {
        this.deleteNode(n.children[k], n, true);
      }
    },

    addConnection(n, conn, label) {
      n.addconnection(conn, OUTGOING, label, 1);
      this.renderchart();
    },

    deleteConnection(n, c) {
      let idx = -1;
      for (var i = 0; n && c && n.connections && i < n.connections.length; i++)
        if (n.connections[i].n.id === c.id) idx = i;

      if (idx > -1) {
        n.connections.splice(idx, 1);
      }

      idx = -1;
      for (
        var j = 0;
        n && c && c.connections && j < c.connections.length;
        j++
      ) {
        if (c.connections[j].n.id === n.id) idx = j;
      }

      if (idx > -1) {
        c.connections.splice(idx, 1);
      }
    },

    displayDeleteDialog: function(e) {
      this.$root.$emit("displayDeleteDialog", e);
    },

    removeActiveNode: function() {
      this.$root.$emit("removeActiveNode");
    },

    editNode: function(e) {
      this.$root.$emit("editNode", e);
    },
    saveNode: function(n) {
      this.rendernode(n, false);
    },

    getPossibleConnections: function(n) {
      let nodes = this.nodes[0].getAllPossibleConnections(n);
      this.$root.$emit("postPossibleConnections", nodes);
    },

    wrapText(nodes, width) {
      var self = this;
      nodes.each(function() {
        self.wrap(this, width, 1, "text.node__title", 40);
        self.wrap(this, width, 5, "text.node__summary", 56);
      });
    },

    wrap(node, width, maxLines, txt, offy) {
      var boxy = parseInt(
        d3
          .select(node)
          .select("rect")
          .attr("y")
      );
      var boxx = parseInt(
        d3
          .select(node)
          .select("rect")
          .attr("x")
      );
      var offx = 0;
      var text = d3.select(node).select(txt),
        words = text
          .text()
          .replace(/((<(br\/?|\/div)>)+)/g, " {{nl}} ")
          //.replace(/<(?!\/?su(p|b)>)[^>]+>/g, "")
          .replace(/&nbsp;+/g, " ")
          .replace(/<p>+/g, "")
          .replace(/<\/p>+/g, txt==='text.node__title'?" ":" {{nl}} ")
          //.replace(/&gt;+/g, ">")
          //.replace(/&lt;+/g, "<")
          .split(/\s+/)
          .reverse(),
        word,
        line = [],
        lineNumber = 0,
        temp = "",
        tspan = text
          .text(null)
          .append("tspan")
          .attr("x", boxx + offx + 10)
          .attr("y", boxy + offy + lineNumber * 14);
      while ((word = words.pop())) {
        if (lineNumber >= maxLines) break;
        if (word.length === 0) continue;
        if (word === "{{nl}}") {
          offx = 0;
          tspan.text(line.join(" "));
          line = [];
          lineNumber++;
          if (lineNumber >= maxLines) {
            if (words.join(" ").length > 0) {
              tspan.text(tspan.text() + "...");
            }
            lineNumber--;
            break;
          }
          tspan = text
            .append("tspan")
            .attr("x", boxx + offx + 10)
            .attr("y", boxy + offy + lineNumber * 14)
            .text("");
          continue;
        }
        if (
          word.indexOf("<sub>") > -1 &&
          (word.indexOf("<sup>") === -1 ||
            word.indexOf("<sup>") > word.indexOf("<sub>"))
        ) {
          if (offx > 0) {
            temp = tspan.text();
            tspan.text(temp + " " + word.replace(/(<[^>]*>)/g, ""));
            if (tspan.node().getComputedTextLength() + offx > width) {
              tspan.text(temp);
              offx = 0;
              lineNumber++;

              if (lineNumber >= maxLines) {
                tspan.text(tspan.text() + "...");
                lineNumber--;
                break;
              }
              line = [];

              tspan = text
                .append("tspan")
                .attr("x", boxx + offx + 10)
                .attr("y", boxy + offy + lineNumber * 14);
            }
          }
          if (word.indexOf("<sub>") > 0)
            line.push(word.slice(0, word.indexOf("<sub>")));
          tspan.text(line.join(" "));
          offx += tspan.node().getComputedTextLength() + 1;
          var sub = text
            .append("tspan")
            .attr("x", boxx + offx + 10)
            .attr("y", boxy + offy + 2 + lineNumber * 14)
            .attr("font-size", "smaller")
            .text(
              word.indexOf("</sub>") > 0
                ? word
                    .slice(word.indexOf("<sub>") + 5, word.indexOf("</sub>"))
                    .replace(/(<[^>]*>)/g, "")
                : word
                    .slice(word.indexOf("<sub>") + 5)
                    .replace(/(<[^>]*>)/g, "")
            );
          offx += sub.node().getComputedTextLength() + 1;
          word =
            word.indexOf("</sub>") > -1
              ? word.slice(word.indexOf("</sub>") + 6)
              : "<sub>" + words.pop();
          //word = word.replace(/(<[^>]*>)/g, "");
          if (word.length > 0) {
            if (offx > 160) {
              text
                .append("tspan")
                .attr("x", boxx + offx + 10)
                .attr("y", boxy + offy + lineNumber * 14)
                .text("-");
              lineNumber++;

              if (lineNumber >= maxLines) {
                tspan.text(tspan.text() + "...");
                lineNumber--;
                break;
              }
              offx = 0;
            }
            line = [];
            tspan = text
              .append("tspan")
              .attr("x", boxx + offx + 10)
              .attr("y", boxy + offy + lineNumber * 14)
              .text("");
            ``;
            words.push(word);
            continue;
          } else {
            var space = text
              .append("tspan")
              .attr("x", boxx + offx + 10)
              .attr("y", boxy + offy + lineNumber * 14)
              .text("\u00A0");
            offx += space.node().getComputedTextLength();
            line = [];
            tspan = text
              .append("tspan")
              .attr("x", boxx + offx + 10)
              .attr("y", boxy + offy + lineNumber * 14)
              .text("");
          }
        }
        if (word.indexOf("<sup>") > -1) {
          if (offx > 0) {
            temp = tspan.text();
            tspan.text(temp + " " + word.replace(/(<[^>]*>)/g, ""));
            if (tspan.node().getComputedTextLength() + offx > width) {
              tspan.text(temp);
              offx = 0;
              lineNumber++;
              if (lineNumber >= maxLines) {
                tspan.text(tspan.text() + "...");
                lineNumber--;
                break;
              }
              line = [];

              tspan = text
                .append("tspan")
                .attr("x", boxx + offx + 10)
                .attr("y", boxy + offy + lineNumber * 14);
            }
          }
          if (word.indexOf("<sup>") > 0)
            line.push(word.slice(0, word.indexOf("<sup>")));
          tspan.text(line.join(" "));
          offx += tspan.node().getComputedTextLength() + 1;
          var sup = text
            .append("tspan")
            .attr("x", boxx + offx + 10)
            .attr("y", boxy + offy - 6 + lineNumber * 14)
            .attr("font-size", "smaller")
            .text(
              word.indexOf("</sup>") > 0
                ? word
                    .slice(word.indexOf("<sup>") + 5, word.indexOf("</sup>"))
                    .replace(/(<[^>]*>)/g, "")
                : word
                    .slice(word.indexOf("<sup>") + 5)
                    .replace(/(<[^>]*>)/g, "")
            );
          offx += sup.node().getComputedTextLength() + 1;
          word =
            word.indexOf("</sup>") > -1
              ? word.slice(word.indexOf("</sup>") + 6)
              : "<sup>" + words.pop();
          if (word.length > 0) {
            if (offx > 170) {
              text
                .append("tspan")
                .attr("x", boxx + offx + 10)
                .attr("y", boxy + offy + lineNumber * 14)
                .text("-");
              lineNumber++;

              if (lineNumber >= maxLines) {
                tspan.text(tspan.text() + "...");
                lineNumber--;
                break;
              }
              offx = 0;
            }
            line = [];
            tspan = text
              .append("tspan")
              .attr("x", boxx + offx + 10)
              .attr("y", boxy + offy + lineNumber * 14)
              .text("");
            words.push(word);
            continue;
          } else {
            var space2 = text
              .append("tspan")
              .attr("x", boxx + offx + 10)
              .attr("y", boxy + offy + lineNumber * 14)
              .text("\u00A0");
            offx += space2.node().getComputedTextLength();
            line = [];
            tspan = text
              .append("tspan")
              .attr("x", boxx + offx + 10)
              .attr("y", boxy + offy + lineNumber * 14)
              .text("");
          }
        }
        if (word.length > 0) line.push(word);
        tspan.text(line.join(" "));
        if (tspan.node().getComputedTextLength() + offx > width) {
          if (line.length === 1) {
            var w = line.pop();
            var over = "";
            if (tspan.node().getComputedTextLength() > width - offx) {
              tspan.text("");
              word = w;
            } else {
              while (tspan.node().getComputedTextLength() + offx > width) {
                over = w.slice(-1) + over;
                w = w.slice(0, w.length - 1);
                tspan.text(w);
              }
              tspan.text(w + "-");
              word = over;
            }
          } else {
            line.pop();
            tspan.text(line.join(" "));
          }
          if (word.length > 0) line = [word];
          offx = 0;
          lineNumber++;
          if (lineNumber >= maxLines) {
            tspan.text(tspan.text() + "...");
            lineNumber--;
            break;
          }
          tspan = text
            .append("tspan")
            .attr("x", boxx + offx + 10)
            .attr("y", boxy + offy + lineNumber * 14)
            .text(word);
          if (tspan.node().getComputedTextLength() > width) {
            var o = "";
            while (tspan.node().getComputedTextLength() > width) {
              o = word.slice(-1) + o;
              word = word.slice(0, word.length - 1);
              tspan.text(word);
            }
            line = [word + "-"];
            words.push(o);
          }
        }
      }
      return lineNumber + 1;
    },

    scrollIntoCenter() {
      var startNode = document.getElementById("i_1").getBoundingClientRect();
      var container = document.getElementById("canvas-container");
      var chart = document.getElementById("svg").getBoundingClientRect();
      var center = (chart.width - window.outerWidth) / 2;
      var nodeWidth = startNode.width / 2;
      var nodeLeft = startNode.left;
      var nodeOff = nodeLeft + nodeWidth - window.outerWidth / 2;
      var calc = nodeOff - center;

      setTimeout(() => {
        container.scrollLeft = calc + center;
      }, 10);
    },

    checkSizeOfSvg() {
      var svgElement = document.getElementById("svg");
      if (window.outerWidth > window.outerHeight) {
        svgElement.style.width = "100&";
        svgElement.style.height = "100%";
      } else {
        svgElement.style.width = "100%";
        svgElement.style.height = "auto";
      }
    }
  }
};